export default __webpack_public_path__ + "static/media/table1.7fc65faf.svg";